export const BASE_URL = process.env.REACT_APP_BASE_URL;

// Helper function to compute age interval text from an array of numbers.
// For example: [0, 1] -> "0-4 Yaş", [0,1,2,3,4,5,6] -> "Tüm Yaşlar"
export const getAgeInterval = (ages: number[]): string => {
  const uniqueAges = Array.from(new Set(ages)).sort((a, b) => a - b);
  if (uniqueAges.length === 0) return '';
  // If all intervals from 0 to 6 are included, return "Tüm Yaşlar"
  if (uniqueAges.length === 7 && uniqueAges[0] === 0 && uniqueAges[6] === 6) {
    return 'Tüm Yaşlar';
  }
  const min = uniqueAges[0];
  const max = uniqueAges[uniqueAges.length - 1];
  return max === 6 ? `${min * 2}+ Yaş` : `${min * 2}-${(max + 1) * 2} Yaş`;
};

export const timeMapping = [
  { value: 100, name: '24 saat açık' },
  { value: 12, name: '06:00' },
  { value: 13, name: '06:30' },
  { value: 14, name: '07:00' },
  { value: 15, name: '07:30' },
  { value: 16, name: '08:00' },
  { value: 17, name: '08:30' },
  { value: 18, name: '09:00' },
  { value: 19, name: '09:30' },
  { value: 20, name: '10:00' },
  { value: 21, name: '10:30' },
  { value: 22, name: '11:00' },
  { value: 23, name: '11:30' },
  { value: 24, name: '12:00' },
  { value: 25, name: '12:30' },
  { value: 26, name: '13:00' },
  { value: 27, name: '13:30' },
  { value: 28, name: '14:00' },
  { value: 29, name: '14:30' },
  { value: 30, name: '15:00' },
  { value: 31, name: '15:30' },
  { value: 32, name: '16:00' },
  { value: 33, name: '16:30' },
  { value: 34, name: '17:00' },
  { value: 35, name: '17:30' },
  { value: 36, name: '18:00' },
  { value: 37, name: '18:30' },
  { value: 38, name: '19:00' },
  { value: 39, name: '19:30' },
  { value: 40, name: '20:00' },
  { value: 41, name: '20:30' },
  { value: 42, name: '21:00' },
  { value: 43, name: '21:30' },
  { value: 44, name: '22:00' },
  { value: 45, name: '22:30' },
  { value: 46, name: '23:00' },
  { value: 47, name: '23:30' },
  { value: 0, name: '00:00' },
];

export const getTime = (time: number) =>
  timeMapping.find((interval) => interval.value === time)?.name;
